export const CONTAINER_NOT_FOUND_ERROR = 'Container Not Found!';
export const UNKNOWN_ERROR = 'Unknown Error Occurred.';
export const INVALID_PRINTER_IP = 'Invalid Printer IP!';
export const CONTAINERIZATION_ERROR = 'Could not Containerize!';
export const CONTAINER_ALREADY_SCANNED_ERROR = 'Container already scanned!';
export const INIT_ERROR = 'Failed to load init data';
export const GET_SORT_TYPES_ERROR = 'Unable to fetch Sort Types';
export const INVENTORY_MOVE_PARTIAL_FAILURE = 'failed to move';